import { i18ntrans } from 'language/i18nkey';
import { useZstdInfo } from 'zstd/useZstdInfo';
import icon_login from './icon/login.svg';
import styled from 'styled-components';

type Props = {};
export const RenderLoginMenu = (props: Props) => {
  const trans = (key: string): string => {
    return i18ntrans.header(key as any);
  };
  const { setShowUserPopup, setShowLoginPopup } = useZstdInfo();
  return (
    <Body>
      <button
        className={'login_btn'}
        onClick={() => {
          setShowLoginPopup(true);
          setShowUserPopup(false);
        }}
        style={{ textAlign: 'center' }}
      >
        <img alt={'popup_login.svg'} src={icon_login} />
        {trans('I18N_TITLE_LOGIN_HEADER')}
      </button>
    </Body>
  );
};

const Body = styled.div`
  padding: 0.85rem 1rem;
  border-radius: 0.8rem;
  font-size: 1.6rem;
  && .login_btn {
    width: 100%;
    text-align: center;
    font-size: 1.6rem;
    padding: 0.55rem 0rem;
    color: #2a2c2f;
  }
  & img {
    vertical-align: middle;
    margin-right: 0.8rem;
  }
`;
